import { render, staticRenderFns } from "./ConflictVisual.vue?vue&type=template&id=340ab534&scoped=true&"
import script from "./ConflictVisual.vue?vue&type=script&lang=js&"
export * from "./ConflictVisual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340ab534",
  null
  
)

export default component.exports